export enum LOCAL_STORAGE_KEYS {
    LAST_SELECTED_NODE_ID = 'LAST_SELECTED_NODE_ID',
    ENERGY_EXPENDITURE_MODE_SELECTED = 'ENERGY_EXPENDITURE_MODE_SELECTED',
    IGNORE_ESTIMATED_ON_WIDGETS = 'IGNORE_ESTIMATED_ON_WIDGETS',
    FEEDS_SHOW_ALL_MESSAGES = 'FEEDS_SHOW_ALL_MESSAGES'
}

export enum SESSION_STORAGE_KEYS {
    SELECTED_DASHBOARD = 'SELECTED_DASHBOARD',
    IFRAME_LAST_VISITED_URL = 'IFRAME_LAST_VISITED_URL',
    SELECTED_PERIOD = 'SELECTED_PERIOD',
    REPORT_PRINT_SESSION = 'REPORT_PRINT_SESSION',
    CURRENT_LANGUAGE = 'CURRENT_LANGUAGE'
}
